export type TicketRequestSubjectInput = {
  subject?: string | null
  email_subject?: string | null
  emailSubject?: string | null
  request_number?: string | null
  id?: string | number | null
  contact_name?: string | null
  contactName?: string | null
  client_name?: string | null
  clientName?: string | null
  client_org?: string | null
  clientOrg?: string | null
  extracted_fields?: Record<string, unknown> | null
  description?: string | null
}

function trimOrEmpty(value: unknown): string {
  if (value == null || value === '') return ''
  return String(value).trim()
}

/**
 * Resolve display/subject for a ticket request.
 * Prefers stored subject, then email subject, then Request ID | Contact | Client.
 */
export function buildTicketRequestSubject(input: TicketRequestSubjectInput): string {
  const explicit = trimOrEmpty(input.subject)
  if (explicit) return explicit

  const extracted = input.extracted_fields ?? {}
  const emailSubject =
    trimOrEmpty(input.email_subject) ||
    trimOrEmpty(input.emailSubject) ||
    trimOrEmpty(extracted.email_subject) ||
    trimOrEmpty(extracted.subject_normalized)
  if (emailSubject) return emailSubject

  const requestId = trimOrEmpty(input.request_number) || (input.id != null ? String(input.id) : '')
  const contactOrClient =
    trimOrEmpty(input.contact_name) ||
    trimOrEmpty(input.contactName) ||
    trimOrEmpty(input.client_name) ||
    trimOrEmpty(input.clientName)
  const clientOrg =
    trimOrEmpty(input.client_org) ||
    trimOrEmpty(input.clientOrg) ||
    trimOrEmpty(input.client_name) ||
    trimOrEmpty(input.clientName)

  const generated = [requestId, contactOrClient, clientOrg].filter(Boolean).join(' | ')
  if (generated) return generated

  const desc = trimOrEmpty(input.description)
  if (desc) return desc.length > 120 ? `${desc.slice(0, 117)}…` : desc

  return requestId ? `Request ${requestId}` : ''
}
